import { render, staticRenderFns } from "./kdxHintText.g.vue?vue&type=template&id=2d00b656&scoped=true"
import script from "./kdxHintText.g.vue?vue&type=script&lang=js"
export * from "./kdxHintText.g.vue?vue&type=script&lang=js"
import style0 from "./kdxHintText.g.vue?vue&type=style&index=0&id=2d00b656&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d00b656",
  null
  
)

export default component.exports